import CloseIcon from "@assets/icons/close.svg";
import DocRegularIcon from "@assets/icons/file-doc-regular.svg";
import DocScoutUploadIcon from "@assets/icons/doc-scout-upload.svg";
import AlertTriangleIcon from "@assets/icons/alert-icon.svg";

import { cn } from "@utils/tailwind.util";
import { getFileExtensionFromContentType } from "@utils/misc.util";
import { getErrorMessagesForDocuments } from "@utils/files.util";
import { TagLabel } from "@ui/Content";

interface IUploadedDocumentsListProps {
  documents: File[];
  onRemove: (index: number) => void;
}

export function UploadedDocumentsList({ documents, onRemove }: IUploadedDocumentsListProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 cursor-pointer">
        <div className="w-10 h-10 flex justify-center items-center">
          <DocScoutUploadIcon
            width={24}
            height={24}
            className=" text-teal-600 dark:text-teal-200"
          />
        </div>

        <h4 className="font-[500] text-sm text-content-primary dark:text-invertedPrimary">
          Create deal details faster
        </h4>
      </div>

      <div className="flex flex-col gap-2">
        {documents.map((document, index) => {
          const isInvalid = getErrorMessagesForDocuments([document]).length > 0;

          return (
            <div
              key={`${document.name}-${document.size}-${index}`}
              className="w-full min-w-0 p-1 flex justify-between items-center gap-2 bg-white dark:bg-gray-800 border dark:border-gray-600 rounded-lg"
            >
              <div
                className={cn("min-w-0 flex items-center gap-1", {
                  "text-content-disabled": isInvalid,
                })}
              >
                <DocRegularIcon
                  width={16}
                  height={16}
                  className="flex-shrink-0 text-content-disabled"
                />
                <TagLabel>{document.name}</TagLabel>
              </div>

              <div
                className={cn(
                  "rounded-md bg-background-tag dark:bg-transparent px-1 py-0.5 text-xs font-medium text-content-primary dark:text-content-secondary",
                  { "opacity-40": isInvalid }
                )}
              >
                {getFileExtensionFromContentType(document.type).replace(".", "").toUpperCase()}
              </div>

              <div className="flex items-center gap-2">
                {isInvalid && (
                  <AlertTriangleIcon
                    width={20}
                    height={20}
                    className="flex-shrink-0 text-red-600"
                  />
                )}
                <button
                  type="button"
                  className=" text-content-secondary hover:text-content-primary dark:hover:text-invertedPrimary80"
                  onClick={() => onRemove(index)}
                  aria-label="Clear search"
                >
                  <CloseIcon
                    width={16}
                    height={16}
                    className="inline-block align-middle dark:text-white"
                  />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
